export const banners = {
  name: '橫幅 |||| 橫幅',
  fields: {
    id: 'ID',
    title: '標題',
    subtitle: '副標題',
    displayType: '顯示類型',
    imageUrl: '圖片網址',
    image: '圖片',
    gradientTheme: '漸變主題',
    gradientStartColor: '漸變起始顏色',
    gradientEndColor: '漸變結束顏色',
    gradientAngle: '漸變角度',
    iconName: '圖示名稱',
    iconColor: '圖示顏色',
    actionType: '動作類型',
    actionTarget: '動作目標',
    actionLabel: '動作按鈕標籤',
    promotionContent: '促銷內容',
    modalButtonText: '彈窗按鈕文字',
    modalButtonAction: '彈窗按鈕動作',
    modalButtonActionType: '彈窗按鈕動作類型',
    modalButtonActionTarget: '彈窗按鈕目標',
    targetType: '目標類型',
    targetMembershipLevels: '目標會員等級',
    targetUsers: '目標用戶',
    isActive: '是否啟用',
    validFrom: '有效開始時間',
    validUntil: '有效結束時間',
    position: '位置',
    displayFrequency: '顯示頻率',
    maxImpressions: '每用戶最大顯示次數',
    createdAt: '建立時間',
    updatedAt: '更新時間',
    impressions: '曝光次數',
    clicks: '點擊次數',
    ctr: '點擊率',
    uniqueUsers: '獨立用戶',
    status: '狀態',
    analytics: '分析',
    validity: '有效期',
    targeting: '目標設定',
    sendPushOnPublish: '發布橫幅時發送推送通知',
    pushTitle: '推送通知標題',
    pushBody: '推送通知內容'
  },
  statistics: '統計',
  statuses: {
    active: '啟用',
    inactive: '停用',
    scheduled: '已排程',
    expired: '已過期'
  },
  filters: {
    search: '搜尋',
    status: '狀態',
    displayType: '顯示類型',
    targetType: '目標類型',
    createdAfter: '建立日期之後',
    createdBefore: '建立日期之前'
  },
  displayTypes: {
    image: '圖片橫幅',
    gradient: '漸變橫幅'
  },
  actionTypes: {
    none: '無動作',
    promotionModal: '促銷彈窗',
    screen: '導航到頁面',
    url: '開啟網址',
    deeplink: '深度連結'
  },
  targetTypes: {
    all: '所有用戶',
    membership: '依會員等級',
    users: '特定用戶',
    newUsers: '僅限新用戶'
  },
  frequencies: {
    always: '總是顯示',
    once: '顯示一次',
    daily: '每日一次',
    weekly: '每週一次'
  },
  memberships: {
    standard: '標準',
    silver: '銀級',
    gold: '金級',
    platinum: '白金',
    vip: 'VIP'
  },
  sections: {
    basicInfo: '基本資訊',
    action: '動作設定',
    modalButton: '彈窗按鈕設定',
    targeting: '目標規則',
    schedule: '排程與顯示',
    translations: '多語言翻譯',
    analytics: '分析與效能',
    bannerContent: '橫幅內容',
    modalContent: '促銷彈窗內容',
    pushNotification: '推送通知'
  },
  tabs: {
    content: '內容',
    targeting: '目標',
    schedule: '排程',
    translations: '翻譯',
    analytics: '分析'
  },
  create: {
    title: '建立新橫幅',
    subtitle: '為您的應用程式建立新的促銷橫幅',
    backToList: '返回橫幅列表',
    createHint: '建立促銷橫幅來透過目標內容和優惠吸引您的應用程式用戶。'
  },
  edit: {
    title: '編輯橫幅',
    subtitle: '編輯橫幅詳情和設定',
    backToList: '返回橫幅列表'
  },
  preview: {
    title: '橫幅預覽',
    mobilePreview: '手機預覽',
    enterContent: '輸入標題和副標題以查看預覽'
  },
  upload: {
    dragAndDrop: '拖放圖片到此處',
    dropHere: '在此放置圖片',
    selectFile: '選擇檔案',
    supportedFormats: 'PNG、JPG、JPEG、WebP 最大 5MB',
    requirements: '建議尺寸：800x400px（2:1 寬高比）',
    uploading: '正在上傳圖片...',
    imageUploaded: '圖片上傳成功',
    fileTooLarge: '檔案過大，最大尺寸為 %{size}',
    invalidFileType: '無效的檔案類型，請上傳圖片檔案',
    uploadError: '上傳圖片失敗，請重試',
    aspectRatio: '最佳顯示比例為 2:1'
  },
  analytics: {
    title: '橫幅分析',
    period: '時間段',
    totalImpressions: '總曝光次數',
    totalClicks: '總點擊次數',
    conversionRate: '點擊率',
    uniqueUsers: '獨立用戶',
    dailyTrend: '每日效能趨勢',
    deviceBreakdown: '設備分析',
    engagement: '互動統計',
    impressionsDesc: '橫幅被顯示的次數',
    clicksDesc: '用戶點擊橫幅的次數',
    conversionDesc: '曝光轉換為點擊的百分比',
    usersDesc: '看到橫幅的獨立用戶數量',
    noData: '此橫幅無可用的分析數據',
    noDeviceData: '無可用的設備分析數據'
  },
  helpers: {
    iconName: '輸入圖示名稱（例如：gift、star、lightning-bolt）',
    position: '數字越小越優先顯示（0 = 最高優先級）',
    maxImpressions: '留空表示無限制顯示',
    screenName: '輸入要導航到的應用程式畫面名稱',
    url: '輸入要開啟的完整網址',
    deeplink: '輸入應用程式深度連結網址',
    modalButtonText: '按鈕顯示文字（留空則不顯示按鈕）',
    subtitleGradientOnly: '副標題僅在漸變橫幅中顯示',
    selectIcon: '點擊選擇圖示',
    pushTitle: '推送通知中顯示的標題（預設使用橫幅標題）',
    pushBody: '推送通知中顯示的內容文字',
    pushNotificationPreview: '推送通知預覽'
  },
  iconPicker: {
    title: '選擇圖示',
    searchPlaceholder: '搜尋圖示...'
  },
  notifications: {
    updated: '橫幅更新成功',
    updateError: '橫幅更新失敗',
    created: '橫幅建立成功',
    createError: '橫幅建立失敗',
    deleted: '橫幅刪除成功',
    deleteError: '橫幅刪除失敗'
  },
  actions: {
    resendPushNotification: '重新發送推送通知'
  },
  validation: {
    titleRequired: '標題為必填項',
    displayTypeRequired: '顯示類型為必填項',
    imageRequired: '圖片橫幅需要上傳圖片',
    invalidUrl: '請輸入有效的網址',
    invalidColor: '請輸入有效的十六進制顏色',
    positionMustBeNumber: '位置必須是數字'
  },
  multilang: {
    title: '多語言翻譯',
    helperText: '為您的橫幅提供不同語言的翻譯。英文為必填，其他語言可選填',
    copyFromBasic: '從主要文字複製',
    translateFromSimplified: '從簡體翻譯',
    translateFromTraditional: '從繁體翻譯',
    titleHelperText: '顯示給用戶的橫幅標題',
    subtitleHelperText: '額外說明的可選副標題文字',
    actionLabelHelperText: '動作按鈕文字（例如："了解更多"、"立即購買"）',
    modalButtonTextHelperText: '促銷彈窗中顯示的按鈕文字',
    promotionContentHelperText: '促銷彈窗中顯示的內容（如果動作類型為促銷）',
    promotionHelperText: '促銷彈窗中顯示的內容（如果動作類型為促銷）',
    nonEnglishNote: '非英文翻譯為可選項，如未提供將使用英文版本'
  }
};